import * as React from 'react'

import Link from '../../../../../../common/Link/Link'
import {urlRegexpString} from '../../../../BuildLog.utils'
import RegExpMatch from '../../RegExpMatch/RegExpMatch'

type Props = {
  children: string
}

const onClick = (e: React.MouseEvent<any>) => {
  e.stopPropagation()
}
const renderMatched = (key: string, text: string): React.ReactNode => (
  <Link key={key} href={text} onClick={onClick} rel="noreferrer">
    {text}
  </Link>
)

const renderUnmatched = (key: string, text: string): React.ReactNode => (
  <span key={key}>{text}</span>
)

const renderNoMatches = (fullText: string): React.ReactNode => fullText

const renderResult = (result: React.ReactNode): React.ReactNode => result

export default function LinkText({children}: Props) {
  const urlRegex = new RegExp(urlRegexpString, 'gi')
  return (
    <RegExpMatch
      text={children}
      regexp={urlRegex}
      renderMatched={renderMatched}
      renderUnmatched={renderUnmatched}
      renderNoMatches={renderNoMatches}
      renderResult={renderResult}
    />
  )
}
